import React from "react";
import AddMilkExpense from "../components/AddMilkExpense";

const AddExpensePage = ({ addExpense }) => {
    return <AddMilkExpense addExpense={addExpense} />;
};

export default AddExpensePage;
